import {
  isCellWithPipeline,
  isCellWithVisualisations,
  isInvalidCell,
  isRecordsLikeCell,
  setCellVisualisations,
} from '@/core/cell';

import { getExplorationCell } from '@/core/exploration';

import { convertVisualisation } from '../input';
import { flattenPipeline, getNumberOfChildPipelines } from '../pipeline/utils';
import { Cell, Exploration } from '../types';
import { restoreInvalidCell } from '.';

export const migrateVisualisations = (exploration: Exploration) => {
  return {
    ...exploration,
    view: {
      ...exploration.view,
      cells: exploration.view.cells.map((cell) => {
        if (
          isRecordsLikeCell(cell) &&
          isCellWithVisualisations(cell) &&
          cell.visualisations !== undefined
        ) {
          return setCellVisualisations(cell, cell.visualisations.map(convertVisualisation));
        }

        return cell;
      }),
    },
  };
};

export const getCellPipeline = (cell: Cell) => {
  if (isCellWithPipeline(cell)) {
    return cell.pipeline;
  }
  if (isInvalidCell(cell)) {
    const validCell = restoreInvalidCell(cell);
    return isCellWithPipeline(validCell) ? validCell.pipeline : undefined;
  }
};

export const getCellBaseModel = (cell: Cell, exploration: Exploration) => {
  const pipeline = getCellPipeline(cell);
  return pipeline !== undefined ? flattenPipeline(pipeline, exploration).baseModelId : undefined;
};

export const isMasterCell = (cellId: string, exploration: Exploration) => {
  const cell = getExplorationCell(exploration, cellId);
  if (cell === undefined) {
    return false;
  }
  const pipeline = getCellPipeline(cell);
  if (pipeline === undefined) {
    return false;
  }
  return getNumberOfChildPipelines(exploration, pipeline) > 0;
};
